import styled from 'styled-components';

export const Snag = styled.div`
  padding: 29px 20px;
  background-color: #ffffff;
  box-shadow: 0 9px 21px 0 rgba(0, 0, 0, 0.08);
  border: solid 1px #f5f5f5;
  margin-top: 20px;
  min-height: 170px;
  & p {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.secondary};
    color: ${props => props.theme.fontColors.headingColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }

  & span {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;

export const Email = styled.p`
  margin: 0;
  & span {
    text-decoration: underline;
    margin-top: 0.4rem;
    display: inline-block;
    @media only screen and (max-width: 720px) {
      margin-top: 0.8rem;
    }
  }
  @media only screen and (max-width: 720px) {
    word-break: break-word;
  }
`;
